import { render, staticRenderFns } from "./TableRowBase.vue?vue&type=template&id=541ae003&scoped=true"
import script from "./TableRowBase.vue?vue&type=script&lang=ts"
export * from "./TableRowBase.vue?vue&type=script&lang=ts"
import style0 from "./TableRowBase.vue?vue&type=style&index=0&id=541ae003&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541ae003",
  null
  
)

export default component.exports